<template>
<div class="chapter">
<div class="inner_page">
<p class="OT">Contents</p>
<p class="TocSb1" id="for"><a id="page_vii"></a><a href="#/xhtml/foreword#for">Foreword <i>by Soong-Chan Rah</i></a></p>
<p class="Toc" id="pre"><a href="#/xhtml/preface#pre">Preface</a></p>
<p class="Toc" id="ack"><a href="#/xhtml/acknowledgements#ack">Acknowledgments</a></p>
<p class="Toc1" id="ch-001"><a href="#/xhtml/chapter001#ch001">1.<span class="space1">Whom Would Jesus Torture?</span></a></p>
<p class="Toc1" id="ch-002"><a href="#/xhtml/chapter002#ch002">2.<span class="space1">What Is the Kingdom of God?</span></a></p>
<p class="Toc1" id="ch-003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">3.<span class="space1">Seek First the Kingdom of God</span></span></p>
<p class="Toc1" id="ch-004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">4.<span class="space1">Living with Dual Citizenship</span></span></p>
<p class="Toc1" id="ch-005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">5.<span class="space1">Aliens in a World of Politics</span></span></p>
<p class="Toc1" id="ch-006"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">6.<span class="space1">How Is the Kingdom Political?</span></span></p>
<p class="Toc1" id="ch-007"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample">7.<span class="space1">When Disobedience Is a Virtue</span></span></p>
<p class="Toc1" id="ch-008"><span href="#/xhtml/chapter008#ch008" title="Link target outside of Sample">8.<span class="space1">Taking Exception to Exceptionalism</span></span></p>
<p class="Toc1" id="ch-009"><span href="#/xhtml/chapter009#ch009" title="Link target outside of Sample">9.<span class="space1">Does Kingdom Service Permit Military Service?</span></span></p>
<p class="Toc1" id="ch-010"><span href="#/xhtml/chapter010#ch010" title="Link target outside of Sample">10.<span class="space05">God Hates Poverty</span></span></p>
<p class="Toc1" id="ch-011"><span href="#/xhtml/chapter011#ch011" title="Link target outside of Sample">11.<span class="space05">“Blessed Are Those Who Suffer Because of Me”</span></span></p>
<p class="Toc1" id="ch-012"><span href="#/xhtml/chapter012#ch012" title="Link target outside of Sample">12.<span class="space05">Being a Kingdom Church</span></span></p>
<p class="Toc" id="note"><span href="#/xhtml/notes#note" title="Link target outside of Sample">Notes</span></p>
<p class="Toc" id="bib"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Select Bibliography</span></p>
<p class="Toc" id="idx-001"><span href="#/xhtml/index001#idx001" title="Link target outside of Sample">Index of Names and Subjects</span></p>
<p class="Toc" id="idx-002"><span href="#/xhtml/index002#idx002" title="Link target outside of Sample">Index of Scripture References</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?85c7dea4